import { motion } from "framer-motion";
import { WhatDoesThisMean } from "../shared/WhatDoesThisMean";

export function OrderVolumeCard({ ordersPlaced, ordersFulfilled, fulfillmentRate, orderBreakdown }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} className="bg-igc-surface border border-igc-gold/15 p-6 h-full" data-testid="order-volume-card">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-4" title="How many orders came in versus how many have actually shipped, and your fulfillment rate.">Order Volume</p>
      <div className="flex items-end gap-6 mb-4">
        <div>
          <p className="font-serif text-3xl text-igc-cream" data-testid="orders-placed-value">{ordersPlaced}</p>
          <p className="text-igc-muted text-xs">Placed</p>
        </div>
        <div>
          <p className="font-serif text-3xl text-igc-cream" data-testid="orders-fulfilled-value">{ordersFulfilled}</p>
          <p className="text-igc-muted text-xs">Fulfilled</p>
        </div>
        <div>
          <p className="font-serif text-3xl text-igc-goldText" data-testid="fulfillment-rate-value">{fulfillmentRate}%</p>
          <p className="text-igc-muted text-xs">
            Fulfillment Rate
            <WhatDoesThisMean
              testId="fulfillment-rate-explainer"
              text={`Your fulfillment rate is ${fulfillmentRate}% — that's the share of your orders that have shipped so far. IGC is actively working to bring this above 95% over the next 60 days.`}
            />
          </p>
        </div>
      </div>
      <div className="border-t border-igc-gold/10 pt-3 max-h-32 overflow-y-auto">
        {orderBreakdown.length === 0 && <p className="text-igc-muted text-xs">No monthly data yet.</p>}
        {orderBreakdown.map((row) => (
          <div key={row.month} className="flex justify-between text-xs py-1 text-igc-muted" data-testid={`order-row-${row.month}`}>
            <span>{row.month}</span>
            <span>{row.placed} placed / {row.fulfilled} fulfilled</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
